<template>
  <div class="credit-card font-[Abel] flex flex-col justify-between overflow-hidden bg-gradient-to-r from-cyan-800 to-cyan-900 dark:from-cyan-950 dark:to-cyan-950 rounded-md h-40 w-64 text-sm text-white p-3 shadow-xl">
    <div class="mb-5 flex justify-between items-center">
      <div>
        <img v-if="isProcessorStripe" src="/images/integrations/stripe_white.png" class="h-5">
        <img v-if="isProcessorSquare" src="/images/integrations/square_white.png" class="h-5">
      </div>
      <div>
        <img v-if="creditCard.cardType.toLowerCase() === 'visa'" src="/images/cards/visa.png" class="h-4">
        <img v-if="creditCard.cardType.toLowerCase() === 'mastercard'" src="/images/cards/mastercard.png" class="h-4">
        <img v-if="creditCard.cardType.toLowerCase() === 'americanexpress' || creditCard.cardType.toLowerCase() === 'amex'" src="/images/cards/amex.png" class="h-4">
      </div>
    </div>
    <div>
      <div class="mb-2">
        <p class="opacity-75 text-sm leading-none">
          {{ $t('components.customer.profile.creditCard.cardNumber') }}
        </p>
        <!-- eslint-disable-next-line vue/no-bare-strings-in-template -->
        <p class="text-xl tracking-tight">
          XXXX XXXX XXXX {{ creditCard.cardLast4 }}
        </p>
      </div>
    </div>
    <div>
      <div class="flex justify-between items-end w-full">
        <div>
          <p class="opacity-75 text-sm leading-none">
            {{ $t('components.customer.profile.creditCard.cardExpiration') }}
          </p>
          <div class="flex items-center space-x-3">
            <template v-if="isStatusActive">
              <p class="text-sm">
                {{ creditCard.cardExpiryMonth }}/{{ creditCard.cardExpiryYear }}
              </p>
            </template>

            <template v-if="isStatusExpiringSoon">
              <o-chip translucent variant="light" size="xs">
                {{ $t('general.colonSeparator', { label1: $t('general.expiresSoon'), label2: `${creditCard.cardExpiryMonth}/${creditCard.cardExpiryYear}` }) }}
              </o-chip>
            </template>

            <template v-if="isStatusExpired">
              <o-chip translucent variant="light" size="xs">
                {{ $t('general.colonSeparator', { label1: $t('general.expired'), label2: `${creditCard.cardExpiryMonth}/${creditCard.cardExpiryYear}` }) }}
              </o-chip>
            </template>
          </div>
        </div>
        <!--<o-description-details term="Card expiration" base-class="">
          {{ creditCard.cardExpiryMonth }}/{{ creditCard.cardExpiryYear }}
        </o-description-details>-->
        <div>
          <o-button
            translucent
            variant="danger"
            size="sm"
            class="-mr-1"
            icon="delete"
            :icon-size="14"
            @click="handleRemove()"
          />
        </div>
      </div>
    </div>

    <div v-if="loading" class="w-full h-full absolute inset-0 bg-white/75 backdrop-blur flex items-center justify-center">
      <o-loader />
    </div>

    <remove-credit-card-action
      ref="removeCreditCardAction"
      :creditCard="creditCard"
      :customer="customer"
      v-model:loading="loading"
      @success="onRemoveSuccess()"
    />
  </div>
</template>

<script setup lang="ts">
import RemoveCreditCardAction from '@/components/customer/actions/CreditCardRemove.vue'

import {
  ODescriptionDetails,
} from '@/components/elements'

interface Props {
  customer: Record<string, any>
  creditCard: Record<string, any>
}

const props = defineProps<Props>()

const { $bus } = useNuxtApp()

const removeCreditCardAction = ref<any>()
const loading = ref(false)

const isExpired = computed(() => false)
const isProcessorStripe = computed(() => props.creditCard.isProcessorStripe)
const isProcessorSquare = computed(() => props.creditCard.isProcessorSquare)
const isStatusActive = computed(() => props.creditCard.isStatusActive)
const isStatusExpiringSoon = computed(() => props.creditCard.isStatusExpiringSoon)
const isStatusExpired = computed(() => props.creditCard.isStatusExpired)

const handleRemove = () => {
  removeCreditCardAction.value.open()
}

const onRemoveSuccess = () => {
  $bus.emit.deleted('CustomerCreditCard', props.creditCard)
}
</script>
